import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../service/app.service';
import { Utente } from '../../interfaces/user';
import { CommonModule } from '@angular/common';
import { AnagraficaEnte } from '../../interfaces/anagrafica-ente.interface';
import { SharedModule } from '../../core/shared.module';
import { concatMap, Observable, of, Subscription } from 'rxjs';
import {
  ItBackButtonComponent,
  ItBreadcrumbComponent,
  ItBreadcrumbItemComponent,
  ItButtonDirective,
  ItIconComponent,
  ItInputComponent,
  ItModalComponent,
  ItNotificationsComponent,
  ItNotificationService,
  ItPaginationComponent,
  ItSortDirective,
  ItSortEvent,
  ItSortHeaderComponent,
  ItTableComponent,
  NotificationPosition,
} from 'design-angular-kit';
import { UnitaOrganizzativaService } from './unita-organizzativa.service';
import { UnitaOrganizzativa } from '../../interfaces/unita-organizzativa.interface';
import { CustomValidator } from '../../shared/validators/custom.validator';

@Component({
  selector: 'app-dettaglio-ente',
  standalone: true,
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    ItModalComponent,
    ItButtonDirective,
    ItInputComponent,
    ItTableComponent,
    ItSortHeaderComponent,
    ItSortDirective,
    ItIconComponent,
    ItNotificationsComponent,
    ItPaginationComponent,
    ItBreadcrumbComponent,
    ItBreadcrumbItemComponent,
    ItBackButtonComponent,
],
providers: [CustomValidator],
  templateUrl: './dettaglio-ente.component.html',
})

export class DettaglioEnteComponent {
  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private router: Router,
    private authService: MsalService,
    private appService: AppService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private unitaOrganizzativaService: UnitaOrganizzativaService,
    private notificationService: ItNotificationService,
    private customValidator: CustomValidator,
  ) {}
  user = this.authService.instance.getAllAccounts()[0];
  pageSubscription = new Subscription();
  utente: Utente = {};
  formEnte: FormGroup = this.fb.group({
    ragioneSociale: [null],
    codiceFiscale: [null],
    codiceAusa: [null],
    dataInizioConvenzione: [null],
    dataFineConvenzione: [null],
    numeroMassimoUtentiAttivi: [null],
  });
  form: FormGroup = this.fb.group({
    descrizione: [null, [Validators.required, Validators.maxLength(255), this.customValidator.noWhiteSpace()]],
    centroDiCosto: [null, [Validators.required, Validators.maxLength(255), this.customValidator.noWhiteSpace()]],
  });
  listUnitaOrganizzativa: UnitaOrganizzativa[] = [];
  ente: AnagraficaEnte = {};
  @ViewChild('unitaOrganizzativaModal') unitaOrganizzativaModal!: ItModalComponent;
  idUnitaOrganizzativa: number = 0;
  totalPages: number = 0;
  currentPage: number = 0;
  pageOffset: number = 10;
  items: any[] = [];

  ngOnInit(): void {
    this.utente = this.appService.user;
    this.ente = this.appService.ente;
    this.listUnitaOrganizzativa = this.route.snapshot.data['data'];
    this.binding();
    this.initBreadcrumb();
  }

  ngAfterViewInit(): void {
    this.getPage();
    this.cd.detectChanges();
  }

  initBreadcrumb(): void {
    if (!this.utente.isUtenteAdmin) {
      this.items = [
        { label: 'Home', link: '/ente' },
        { label: 'Anagrafica Ente' },
      ];
    } else {
      this.items = [
        { label: 'Home', link: '/home' },
        { label: `${this.ente.ragioneSociale}`, link: '/ente' },
        { label: 'Anagrafica Ente' },
      ];
    }
  }

  listInit(list: UnitaOrganizzativa[]): void {
    this.listUnitaOrganizzativa = list;
    this.cd.detectChanges();
  }

  binding(): void {
    if (this.ente) {
      this.ente.dataInizioConvenzione = this.ente.dataInizioConvenzione?.split('T')[0];
      this.ente.dataFineConvenzione = this.ente.dataFineConvenzione?.split('T')[0];
      this.formEnte.patchValue(this.ente);
    }
  }

  add(): void {
    this.form.reset();
    this.idUnitaOrganizzativa = 0;
    this.unitaOrganizzativaModal.show();
  }

  edit(element: any): void {
    this.unitaOrganizzativaModal.show();
    this.idUnitaOrganizzativa = element.idUnitaOrganizzativa;
    this.form.patchValue(element);
    this.ente.isSolaLettura ? this.form.disable({ emitEvent : false }) : this.form.enable({ emitEvent : false });
    this.form.markAllAsTouched();
  }

  delete(element: UnitaOrganizzativa): void {
    if (!element.isCancellazioneConsentita) {
      return;
    }
    this.pageSubscription.add(
      this.unitaOrganizzativaService.delete(element.idUnitaOrganizzativa).pipe(
        concatMap((result) => {
          if (result) {
            this.loader.show();
            return this.unitaOrganizzativaService.list();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (el: UnitaOrganizzativa[]) => {
        if (el) {
          this.notificationService.success(
            'Dati eliminati con successo!', '', false, 3000, NotificationPosition.Bottom
          );
          this.listInit(el);
        }
      },
      error: () => this.loader.hide(),
      complete: () => this.loader.hide(),
    }));
  }

  sortData(event: ItSortEvent): void {
    this.getPage(this.currentPage, event);
  }

  redirect(url: string) {
    this.router.navigate([url]);
  }

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    const formValues = this.form.value;
    const dataToSend = {
      idUnitaOrganizzativa: this.idUnitaOrganizzativa,
      idEnte: this.ente.idEnte,
      descrizione: formValues.descrizione,
      centroDiCosto: formValues.centroDiCosto,
    }
    this.pageSubscription.add(
      this.unitaOrganizzativaService.post(dataToSend).pipe(
        concatMap((result) => {
          if (result) {
            this.loader.show();
            return this.unitaOrganizzativaService.list();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (el: UnitaOrganizzativa[]) => {
          if (el) {
          this.unitaOrganizzativaModal.hide();
          this.notificationService.success(
            `Dati ${
              this.idUnitaOrganizzativa ? 'modificati' : 'salvati'
            } con successo!`, '', false, 3000, NotificationPosition.Bottom
          );
          this.listInit(el);
        }
      },
      error: () => this.loader.hide(),
      complete: () => this.loader.hide(),
    }));
  }

  getPage(page: number = 0, sort?: ItSortEvent): void {
    this.loader.show();
    this.paginator(page, this.pageOffset)
      .subscribe(data => {
        data.list = data.list.sort((a, b) => {
          if (sort?.direction === 'asc') {
            return a[sort.active] > b[sort.active] ? 1 : -1;
          } else if (sort?.direction === 'desc') {
            return a[sort.active] < b[sort.active] ? 1 : -1;
          }
          return 0;
        });
        this.listInit(data.list);
        this.currentPage = page;
        this.totalPages = Math.ceil(data.totalItemsCount / this.pageOffset);
        this.loader.hide();
      });
  }

  changerEvent(value: number): void {
    this.pageOffset = value;
    this.getPage();
  }

  private paginator(page: number, pageOffset: number): Observable<{ list: UnitaOrganizzativa[]; totalItemsCount: number }> {
    const startIndex = (page) * pageOffset;
    const endIndex = startIndex + pageOffset;
    const list = this.route.snapshot.data['data'].slice(startIndex, endIndex);

    return of({
      list: list,
      totalItemsCount: this.route.snapshot.data['data'].length,
    });
  }

  ngOnDestroy(): void {
    this.pageSubscription.unsubscribe();
  }
}
